module.exports = __webpack_public_path__ + "static/img/ppyy_banner.f5a0825.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ppyy_banner.jpg
// module id = 0/za
// module chunks = 1